import {PageType} from '../api/models';

export enum Color {
    SEA_GREEN = '#519872',
    FELDGRAU = '#3B5249',
    ASH_GRAY = '#BEC5AD',
    SAGE = '#A4B494',
    WHITE = '#FFF',
    BLACK = '#15171C',
    APPBAR_GREEN = '#4B7C62',
}

export interface WebsiteTheme {
    backgroundColor: Color;
    primaryTextColor: Color;
    secondaryTextColor: Color;
}

export const getWebsiteTheme = (index: number, pageType: PageType): WebsiteTheme => {
    const isEven = index % 2 === 0;
    switch (pageType) {
        case PageType.LANDING_PAGE:
            return {
                backgroundColor: isEven ? Color.SEA_GREEN : Color.WHITE,
                primaryTextColor: isEven ? Color.WHITE : Color.SEA_GREEN,
                secondaryTextColor: isEven ? Color.WHITE : Color.BLACK,
            };
        case PageType.DASHBOARD_SCREEN:
            return {
                backgroundColor: isEven ? Color.SEA_GREEN : Color.WHITE,
                primaryTextColor: isEven ? Color.WHITE : Color.BLACK,
                secondaryTextColor: isEven ? Color.WHITE : Color.BLACK,
            };
    }
};
